import React from "react"
import styles from "./autocomplete.module.css"

/**
 * @typedef {Object} AutocompleteOption
 * @property {string | number} id
 * @property {string} label
 * @property {any} [data]
 */

/**
 * @typedef {Object} AutocompleteProps
 * @property {AutocompleteOption[]} options
 * @property {AutocompleteOption | null} value
 * @property {boolean} withLoading
 * @property {(option: AutocompleteOption) => void} [onChange]
 */

/**
 * @param {AutocompleteProps} props 
 */
export function Autocomplete({ options = [], value = null, isLoading = false, onChange }) {
  const handleChange = (option) => {
    if (typeof onChange !== "function") return
    onChange(option)
  }

  if (!options.length) {
    return null
  }

  return (
    <div className={styles.wrapper} tabIndex={-1}>
      <div className={styles.content}>
        <ul data-slot="list" className={styles.list}>
          {options.map((option) => {
            const isSelected = value?.id === option.id
            return (
              <li
                key={option.id}
                data-slot="item"
                data-selected={isSelected}
                onClick={() => handleChange(option)}
              >
                <span data-slot="itemLabel">{option.label}</span>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}
